import { useState } from 'react';
import type { PhieuXuatKho } from '@/types/schemas/phieu-xuat-kho.type';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const usePhieuXuatKhoExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportPhieuXuatKhoExcel, exportPhieuXuatKhoFromApi } = await import('../utils/excel-export');
      if (entity?.slug) {
        await exportPhieuXuatKhoFromApi({
          entitySlug: entity.slug
        });
        return;
      }

      await exportPhieuXuatKhoExcel();
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
